import ProgressBar from './component-progress-bar'

const Contribution = {
  props: ['articleContent', 'nextPart', 'accentColor'],
  component: [
    ProgressBar
  ],
  methods: {
    onTransitionLeave() {
      window.scrollTo(0, 0)
    }
  },
  template: `
    <section id="contribution">

      <progress-bar :color="accentColor"></progress-bar>

      <div class="container" ref="container">

        <transition name="fade-delay" appear mode="out-in" @after-leave="onTransitionLeave">

          <router-view></router-view>

        </transition>

      </div>

    </section>
  `
}

export default Contribution
